<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-container fluid full-height grid-list-md>
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}</router-link
                >
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs12>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">{{ responseError }}</span>
              </v-flex>
              <v-flex sm3>
                <v-select
                  v-model="queryParams.shopId"
                  :items="shopList"
                  color="blue-grey lighten-2"
                  label="Choose Shop..."
                  menu-props="auto"
                  item-text="name"
                  item-value="id"
                  :readonly="user.shopId"
                  @change="changeShop()"
                ></v-select>
              </v-flex>
              <v-flex sm3>
                <v-select
                  v-model="queryParams.financeSettingId"
                  :items="financeSettingList"
                  color="blue-grey lighten-2"
                  label="Choose Finance Setting..."
                  item-text="financialYearName"
                  menu-props="auto"
                  item-value="id"
                  @input="bindMonth(queryParams.financeSettingId)"
                ></v-select>
              </v-flex>
              <v-flex sm3>
                <v-menu
                  ref="menu"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="queryParams.fromMonth"
                      label="From Month"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="queryParams.fromMonth"
                    :min="minMonth"
                    :max="maxMonth"
                    type="month"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm3>
                <v-menu
                  ref="menu"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="queryParams.toMonth"
                      label="To Month"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="queryParams.toMonth"
                    :min="minMonth"
                    :max="maxMonth"
                    type="month"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm4>
                <v-radio-group
                  v-model="queryParams.trialBalanceType"
                  :mandatory="false"
                  row
                >
                  <v-radio label="All" value="ALL"></v-radio>
                  <v-radio label="With Balance" value="WITHBALANCE"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex sm4>
                <v-btn outline color="primary" @click="onSearch">Preview</v-btn>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
        <v-flex xs12 class="mt-1">
          <v-card>
            <v-flex xs12 ml-2 pt-4>
              <div style="float: left; padding-left: 15px">
                <h3 style="margin: 0px; color: blue" id="counter">
                  Trial Balance
                </h3>
              </div>
            </v-flex>
            <v-flex xs12 ml-2 pt-4>
              <div style="float: left; padding-left: 11px">
                <p
                  style="font-size: 13px; margin: 0px; font-weight: bold"
                  id="counter"
                >
                  Shop Name : {{ shopName }}
                </p>
              </div>
            </v-flex>
            <v-flex xs12 ml-2 pt-4>
              <div style="float: left; padding-left: 11px">
                <p
                  style="font-size: 13px; margin: 0px; font-weight: bold"
                  id="counter"
                >
                  For {{ queryParams.fromMonth }} - {{ queryParams.toMonth }}
                </p>
              </div>
            </v-flex>
            <v-flex xs12 ml-2 pt-4>
              <div style="float: left; padding-left: 11px">
                <h4 style="margin: 0px; color: blue" id="counter">
                  Summary Of Active Accounts
                </h4>
              </div>
            </v-flex>
            <v-flex xs12 ml-2 pt-4>
              <div
                style="width: 100%; height: 3px; background-color: blue"
              ></div>
            </v-flex>
            <v-data-table
              :headers="headers"
              :items="trialBalanceDetailList"
              class="elevation-1"
              :loading="showListLoading"
              hide-actions
            >
              <template slot="items" slot-scope="props">
                <tr
                  v-if="
                    (queryParams.trialBalanceType == 'WITHBALANCE'
                      ? props.item.debitAmount > 0 ||
                        props.item.creditAmount > 0
                      : true) && !props.item.chartOfAccount.isHide
                  "
                >
                  <td>{{ props.item.chartOfAccount.code }}</td>
                  <td>{{ props.item.chartOfAccount.accName }}</td>
                  <td>
                    {{ props.item.chartOfAccount.accounthead.accountName }}
                  </td>
                  <td
                    style="
                      width: calc(100% / 7);
                      overflow: hidden;
                      text-align: right;
                    "
                    class="text-xs"
                  >
                    <span v-if="props.item.chartOfAccount.nature == 'DR'">
                      {{ props.item.closingBalance | decFormat(6) }}
                    </span>
                  </td>
                  <td
                    style="
                      width: calc(100% / 7);
                      overflow: hidden;
                      text-align: right;
                    "
                    class="text-xs"
                  >
                    <span v-if="props.item.chartOfAccount.nature == 'CR'">
                      {{ props.item.closingBalance | decFormat(6) }}
                    </span>
                  </td>
                </tr>
              </template>
              <template slot="footer">
                <td colspan="3">Total</td>
                <td style="text-align: right">
                  {{ totalDebitAmount | decFormat(6) }}
                </td>
                <td style="text-align: right">
                  {{ totalCreditAmount | decFormat(6) }}
                </td>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>

        <v-flex sm12>
          <div class="text-xs-center">
            <v-btn color="primary" @click="printInvoice('trialPrint')"
              >PRINT</v-btn
            >
            <v-btn color="success" :loading="exportLoading" @click="exportAll">
              Export
            </v-btn>
          </div>
        </v-flex>
      </v-layout>

      <!-- Trial print hidden area -->
      <!-- <trial id="trialPrint"></invoice> -->
      <div
        id="trialPrint"
        style="bsale: 1px solid black; width: 300px"
        v-show="false"
      >
        <div style="text-align: center; padding-bottom: 5px">
          <p style="font-size: 15px; margin: 0px; font-weight: bold">
            Trial Balance
          </p>
        </div>

        <div style="text-align: center">
          <p style="font-size: 11px; margin: 0px"></p>
        </div>
        <div style="float: left; padding-left: 11px">
          <p style="font-size: 13px; margin: 0px" id="counter">
            Shop Name : {{ shopName }}
          </p>
        </div>
        <div style="float: right; padding-right: 11px">
          <p style="font-size: 13px; margin: 0px" id="counter">
            From Month :
            {{ queryParams.fromMonth }}
          </p>
        </div>
        <br />
        <div style="float: right; padding-right: 11px">
          <p style="font-size: 13px; margin: 0px" id="counter">
            Account Type : {{ queryParams.trialBalanceType }}
          </p>
        </div>
        <div style="float: left; padding-left: 11px">
          <p style="font-size: 13px; margin: 0px" id="casher">
            To Month: {{ queryParams.toMonth }}
          </p>
        </div>
        <br />
        <div style="float: left; padding-left: 11px; padding-top: 5px">
          <p
            style="font-size: 13px; margin: 0px; font-weight: bold"
            id="casher"
          >
            Summary Of Active Accounts
          </p>
        </div>
        <div style="clear: both"></div>
        <div style="height: 10px"></div>
        <div style="padding-left: 5px; padding-right: 5px">
          <table
            style="
              font-family: arial, sans-serif;
              border-collapse: collapse;
              width: 100%;
              font-size: 11px;
            "
          >
            <thead
              style="
                border-bottom: 1px solid black;
                border-top: 1px solid black;
              "
            >
              <tr style="line-height: 20px">
                <th style="border: 1px solid black; text-align: center">
                  Account Code
                </th>
                <th style="border: 1px solid black; text-align: center">
                  Account Name
                </th>
                <th style="border: 1px solid black; text-align: center">
                  Account Head
                </th>
                <th style="border: 1px solid black; text-align: center">
                  Debit
                </th>
                <th style="border: 1px solid black; text-align: center">
                  Credit
                </th>
              </tr>
            </thead>
            <tbody v-for="(item, index) in trialBalanceDetailList" :key="index">
              <tr
                v-if="
                  (queryParams.trialBalanceType == 'WITHBALANCE'
                    ? item.debitAmount > 0 || item.creditAmount > 0
                    : true) && !item.chartOfAccount.isHide
                "
                style="line-height: 20px"
              >
                <td style="border: 1px solid black; text-align: center">
                  <span>{{ item.chartOfAccount.code }}</span>
                </td>
                <td style="border: 1px solid black; text-align: left">
                  <span>{{ item.chartOfAccount.accName }}</span>
                </td>
                <td style="border: 1px solid black; text-align: left">
                  {{ item.chartOfAccount.accounthead.accountName }}
                </td>
                <td style="border: 1px solid black; text-align: right">
                  <span v-if="item.chartOfAccount.nature == 'DR'">
                    {{ item.closingBalance | decFormat(6) }}
                  </span>
                </td>
                <td style="border: 1px solid black; text-align: right">
                  <span v-if="item.chartOfAccount.nature == 'CR'">
                    {{ item.closingBalance | decFormat(6) }}
                  </span>
                </td>
              </tr>
            </tbody>
            <tr style="line-height: 20px">
              <td colspan="3" style="border: 1px solid black">Total</td>
              <td style="border: 1px solid black; text-align: right">
                {{ totalDebitAmount | decFormat(6) }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ totalCreditAmount | decFormat(6) }}
              </td>
            </tr>
          </table>
          <div style="height: 10px"></div>
        </div>
      </div>
      <!-- End print  -->
    </v-container>
  </v-form>
</template>
  <script>
import { trialBalanceService } from "../../services/trial-balance-service";
import { shopService } from "../../services/shop-service";
import { TrialBalance } from "../../models/model";
import { commonService } from "../../services/common-service";
import { financeSettingService } from "../../services/finance-setting-service";
export default {
  name: "CashTrialBalanceList",
  components: {},
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    breadcrumbs: [
      {
        text: "Finance",
        disabled: true,
      },
      {
        text: "Cash Trial Balance",
        disabled: true,
      },
    ],
    valid: true,
    showListLoading: false,
    exportLoading: false,
    menu: false,
    responseError: "",
    shopName: "",
    financeSettingId: "",
    yearAndMonthInMilliSeconds: "",
    decimalFormat: "",
    fromDate: "",
    toDate: "",
    minMonth: "",
    maxMonth: "",
    shopList: [],
    financeSettingList: [],
    trialBalanceDetailList: [],
    cashTrial: new TrialBalance(),
    totalDebitAmount: 0,
    totalCreditAmount: 0,
    totalDifferentAmount: 0,
    selectedIndex: 0,
    queryParams: {
      financeSettingId: "",
      shopId: "",
      trialBalanceType: "ALL",
      fromMonth: new Date().toISOString().substr(0, 7),
      toMonth: new Date().toISOString().substr(0, 7),
    },
    headers: [
      { text: "Account Code", value: "accountParent.code", sortable: false },
      { text: "Account Name", value: "accountParent.accName", sortable: false },
      { text: "Account Head", value: "accounthead", sortable: false },
      { text: "Debit", value: "debit", align: "center", sortable: false },
      { text: "Credit", value: "credit", align: "center", sortable: false },
    ],
  }),
  created() {
    this.getFinanceSettingList();
    if(this.user.shopId){
      this.queryParams.shopId = this.user.shopId;
    }
    this.getShopList();
    //for deep linking
    const id = this.$route.params.id;
    if (id == "new") {
      // new trial balance
    }
    this.decimalFormat = commonService.formatdecimal();
  },
  methods: {
    onSearch() {
      this.getCashTrialDetailList();

      this.yearAndMonthInMilliSeconds = commonService.convertToMilliseconds(
        this.queryParams.yearAndMonth
      );
      if (this.queryParams.financeSettingId) {
        this.financeSettingId = this.queryParams.financeSettingId;
      }
      this.fromDate = commonService.millisecondToDate(
        parseInt(this.yearAndMonthInMilliSeconds),
        "YYYY-MM-DD"
      );
      let startDate = new Date(this.fromDate);
      let endDate = new Date(
        startDate.getFullYear(),
        startDate.getMonth() + 1,
        0
      );
      this.fromDate = commonService.formatDate(startDate, "MMMM DD YYYY");
      this.toDate = commonService.formatDate(endDate, "MMMM DD YYYY");
    },
    getCashTrialDetailList() {
      this.showListLoading = true;
      trialBalanceService
        .getCashTrialBalance(this.queryParams)
        .then((res) => {
          this.trialBalanceDetailList = res.data.trialBalanceDetailList;
          this.totalDebitAmount = res.data.totalDebitAmount;
          this.totalCreditAmount = res.data.totalCreditAmount;
          this.totalDifferentAmount = res.data.totalDifferentAmount;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    getShopList() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
          let findAll = {
            id: "",
            name: "----All----",
          };
          this.shopList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch((err) => {
          console.error(err);
        });
    },
    goBack() {
      this.$router.push("/trial-balances");
    },
    printInvoice(divName) {
      var printContents = document.getElementById(divName).innerHTML;

      // var originalContents = document.body.innerHTML;
      var myWindow = window.open("", "MsgWindow", "width=350,height=500");
      myWindow.document.write(printContents);

      // document.body.innerHTML = printContents;
      myWindow.print();

      // document.body.innerHTML = originalContents;
      myWindow.close();

      // clear previous cart item
    },
    getFinanceSettingList() {
      financeSettingService
        .getAllFinanceSetting()
        .then((res) => {
          this.financeSettingList = res.data.financeSettingDTOs;
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data) {
            this.response = err.response.data.message;
          }
        });
    },
    bindMonth(id) {
      let financeSetting = commonService.search(
        "id",
        id,
        this.financeSettingList
      );
      this.minMonth = financeSetting.startMonth;
      this.maxMonth = financeSetting.endMonth;
      this.queryParams.fromMonth = financeSetting.startMonth;
      this.queryParams.toMonth = financeSetting.endMonth;
    },
    changeShop() {
      if (this.queryParams.shopId) {
        let shop = commonService.search(
          "id",
          this.queryParams.shopId,
          this.shopList
        );
        this.shopName = shop.name;
      } else {
        this.shopName = "";
      }
    },
    exportAll() {
      this.exportLoading = true;
      trialBalanceService
        .exportCashTrialBalance(this.queryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.exportLoading = false;
        });
    },
  },
};
</script>
  